import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AboutMeModal } from "./AboutMeModal";

export const AboutMe = ({ aboutMeData, fetchData, isCurrentUserProfile }) => {
  const { t } = useTranslation();

  const [aboutMeModal, setShowAboutMeModal] = useState(false);

  const toggleAboutMeModal = () => {
    setShowAboutMeModal((prev) => !prev);
  };

  return (
    <>
      <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
        <div className="d-flex flex-wrap justify-content-between align-items-center column-gap-3 row-gap-2 mb-3">
          <h4 className="mb-0 text-md font-semibold text-grey-800">About Me</h4>
          {isCurrentUserProfile && (
            <div className="d-flex align-items-center gap-1">
              <button
                type="button"
                className="btn btn-gray-light font-medium rounded-lg d-inline-flex align-items-center gap-1"
                onClick={() => toggleAboutMeModal()}
              >
                <i className="bx bx-pencil"></i> Edit
              </button>
            </div>
          )}
        </div>
        <div>
          {aboutMeData ? (
            <span>{aboutMeData}</span>
          ) : (
            <span className="text-grey-400">
              {t("auth.viewProfile.noAboutMe")}
            </span>
          )}
        </div>
      </div>

      {aboutMeModal && (
        <AboutMeModal
          show={aboutMeModal}
          aboutMeData={aboutMeData}
          toggle={toggleAboutMeModal}
          fetchData={fetchData}
        />
      )}
    </>
  );
};
